// @ts-nocheck
import React, { memo } from "react";
import { useHistory } from "react-router";
import {
  Button,
  Box,
  Typography,
} from "@material-ui/core/";

const RegistrationText = ({ message }) => {
  const history = useHistory();
  return (
    <Box
      p={2}
      width={1}
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100%"
      flexDirection="column"
    >
      <Typography variant="h3">{message}</Typography>
      <Box pt={4}>
        <Button
          color="primary"
          variant="contained"
          onClick={() => history.push("/log-in")}
        >
          Go to Login
        </Button>
      </Box>
    </Box>
  );
};

export default memo(RegistrationText);
